jQuery(document).ready(function () {

    // slick for testimonial posts
	if ( jQuery( "section.ticker-tape-section .ticker-wrap .ticker" ).length ) {
		jQuery('section.ticker-tape-section .ticker-wrap .ticker').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow : '<button type="button" class="previous fa-thin fa-arrow-left general">Previous</button>',
			nextArrow : '<button type="button" class="next fa-thin fa-arrow-right general">Next</button>',
			dots: false,
			arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 20000,
            pauseOnHover: false,
            cssEase: 'linear'
		});
	}

	// slick for testimonial posts
	if ( jQuery( "section.page.page--product .top-section .product-container .product-images-container .image-block.gallery-version .inner" ).length ) {
		jQuery('section.page.page--product .top-section .product-container .product-images-container .image-block.gallery-version .inner').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow : '<button type="button" class="previous fa-thin fa-arrow-left general">Previous <svg width="22" height="42" viewBox="0 0 22 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 40.707L1 20.707L21 0.707031" stroke="#505050" stroke-width="2" stroke-linejoin="round"/></svg></button>',
			nextArrow : '<button type="button" class="next fa-thin fa-arrow-right general">Next <svg width="22" height="42" viewBox="0 0 22 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.707031 40.707L20.707 20.707L0.707031 0.707031" stroke="#505050" stroke-width="2" stroke-linejoin="round"/></svg></button>',
			dots: false,
			arrows: true
		});
	}

});